var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.getForumPath,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('span',{staticClass:"primary--text pointer",on:{"click":function($event){return _vm.onClickRoute(item)}}},[_vm._v(_vm._s(item.title))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }